/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { LocationSuggestionOptionType } from './LocationSuggestion.types';

/* Option is what gets passed into the Autosuggest component as items */
export type SectionOption = {
    text?: string;
    children: LocationSuggestionOptionType[];
    id: string;
};

export function isSectionOption(
    option: SectionOption | LocationSuggestionOptionType
): option is SectionOption {
    return (option as SectionOption).children !== undefined;
}
